export const getCursorStyle = (hasAlert: boolean) => {
  return { cursor: hasAlert ? "pointer" : "default" };
};
